var link_viewer_default = {
  "fontElementMap": "MkZWX",
  "link": "_2WAyZ",
  "linkInEditor": "h-C5Z",
  "linkInViewer": "xaIkt",
  "toolbarUrlContainer": "t5mXc",
  "toolbarUrl": "W1XxS",
  "toolbarUrlAnchor": "J5QXZ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
